module.exports = __webpack_public_path__ + "static/media/graph.d7cdff2a.png";